import { PrivateRoute } from "../components/privateRoute";
import authService from "../services/authService";

const tokenExpired = (error) => {
  if (error.response.status === 401) {
    authService.logout();
    return <PrivateRoute />;
  }
};

export default tokenExpired;
